import React from 'react';
import 'vis-timeline/styles/vis-timeline-graph2d.css';
import { 
  Box,
  Flex,
  Text,
  Circle 
} from '@chakra-ui/react';
import { 
  Legend,
  AreaChart, 
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

interface Score {
  date?: string;
  year?: number;
  min?: number | null;
  threshold_budget?: number | null;
  avg_budget?: number | null;
  max_budget?: number | null;
}

interface TresholdScoreGraphProps {
  scores: Score[];
  eduLevel: number;
  color: string;
}

const TresholdScoreGraph: React.FC<TresholdScoreGraphProps> = ({ scores, eduLevel, color }) => {

  const data: Score[] = [];

  scores.forEach((element) => {
        data.push({
          date: `${element.year}`,
          min: element.min,
          threshold_budget: element.threshold_budget ? 
             element.threshold_budget / 1000  :
            null,
          avg_budget: element.avg_budget ? 
             element.avg_budget / 1000  :
            null,
            max_budget: element.max_budget ? 
            element.max_budget / 1000  :
           null,
        });
  })

  let maxScore = data.reduce((max, p) => p.threshold_budget ? p.threshold_budget > max ? p.threshold_budget : max : max, 0) + 5;

  //Получить равномерные деления для оси Y
  const step = Math.floor(maxScore / 15) ;
  const ticks = [];
  for (let i = 0; i < 16; i++) {
    ticks.push(i * step);
  }

  const translateData: any = {
    min: 'Минимальный балл',
    threshold_budget: 'Проходной балл',
    avg_budget: 'Средний балл',
    max_budget: 'Максимальный балл'
  };

  return (
    <Box>
      <Text as='b' fontSize='26px'>Динамика проходного балла</Text>
      <Box mt='20px'>
        <ResponsiveContainer width="100%" height={450}>
          <AreaChart data={data}>
            <defs>
              <Box fill={"#E48F0D"} id="colorMinScore">
                {/* <stop offset="5%" stopColor="#E48F0D" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#E48F0D" stopOpacity={0}/> */}
              </Box>
              <linearGradient id="colorTresholdScore" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.8}/>
                <stop offset="95%" stopColor={color} stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorAvgScore" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#891C57" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#891C57" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorMaxScore" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8ACE00" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#8ACE00" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis dataKey="date" />
            <YAxis ticks={ticks}/>
            <CartesianGrid strokeDasharray="1 0" />
            <Tooltip 
              formatter={(value, name, props) => [value, translateData[name]]}
            />
            <Area 
              type="monotone" 
              dataKey="threshold_budget" 
              stroke={color} 
              fillOpacity={0} 
              fill="url(#colorTresholdScore)" 
            />
            <Area 
              type="monotone" 
              dataKey="min" 
              stroke="#E48F0D" 
              fillOpacity={0} 
              fill="url(#colorMinScore)" 
            />
            <Area 
              type="monotone" 
              dataKey="avg_budget" 
              stroke="#891C57" 
              fillOpacity={0} 
              fill="url(#colorAvgScore)" 
            />
            <Area 
              type="monotone" 
              dataKey="max_budget" 
              stroke="#8ACE00" 
              fillOpacity={0} 
              fill="url(#colorMaxScore)" 
            />
          </AreaChart>
        </ResponsiveContainer>
        <Flex justifyContent="center" gap="20px">
          <Flex>
            <Flex alignItems="center">
              <Circle 
                size="10px" 
                bg="#E48F0D" 
                mt="3px"
                mr={2} 
              />
            </Flex>
            <Text
              color="#E48F0D"
              m={0}
            >
              Минимальный балл
            </Text>
          </Flex>
          <Flex>
            <Flex alignItems="center">
              <Circle 
                size="10px" 
                bg={color}
                mt="3px" 
                mr={2} 
              />
            </Flex>
            <Text
              color={color}
              m={0}
            >
              Проходной балл
            </Text>
          </Flex>
          <Flex>
            <Flex alignItems="center">
              <Circle 
                size="10px" 
                bg="#891C57"
                mt="3px" 
                mr={2} 
              />
            </Flex>
            <Text
              color="#891C57"
            >
              Средний балл
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default TresholdScoreGraph;
